import type { Locale } from '@viet-parenting/content/i18n';
import type { DetailContext } from '@viet-parenting/content/detail';
import { cfImageUrl } from './cf-images';

/**
 * The context the public detail components get when they render inside the
 * preview modal. Every link is dead — the modal intercepts clicks anyway — and
 * the report link is dropped, since reporting your own unpublished draft makes
 * no sense.
 */
export function previewContext(locale: Locale): DetailContext {
  return {
    locale,
    imageUrl: cfImageUrl,
    hrefs: { back: '#', home: '#', report: null },
  };
}

/**
 * Placeholder identity for a row that has not been inserted yet, so the
 * preview can render a brand-new draft the same way as a saved one.
 */
export function draftIdentity(slugSeed: string) {
  const now = new Date().toISOString();
  return {
    id: 'preview',
    slug: slugSeed || 'preview',
    created_at: now,
    updated_at: now,
  };
}
